export const PopStartingHeight = '600px';
export const PopUpHeight = '90%';
export const PopUpMaxHeight = '900px';
export const PopUpWidth = '828px';
export const PopUpWidthSmall = '508px';
export const PopUpStyling = 'popup-dialog-container';
